import { SettingsNavigationState } from "./SettingsNavigationState";
import type { ReactNode } from "react";
import {
  UserRound,
  ShieldCheck,
  SlidersHorizontal,
  Plug,
  Database,
  CreditCard,
  Monitor,
  ArchiveRestore,
  Code2,
} from "lucide-react";
import { SettingsErrorBoundary } from "./SettingsUI";
export const SETTINGS_ICONS = {
  embeds: Code2,
  profile: UserRound,
  security: ShieldCheck,
  permissions: SlidersHorizontal,
  connections: Plug,
  data: Database,
  transfer: ArchiveRestore,
  billing: CreditCard,
  compute: Monitor,
};
export default function SettingsLayout({
  route,
  children,
}: {
  route: string;
  children: ReactNode;
}) {
  return (
    <SettingsNavigationState>
      <div className="settings-workspace">
        <div className="settings-content">
          <SettingsErrorBoundary key={route}>{children}</SettingsErrorBoundary>
        </div>
      </div>
    </SettingsNavigationState>
  );
}
